import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { BrandForm } from "../components/BrandForm";
import { Button } from "../components/ui/button";
import { Spinner } from "../components/AiHtml";
import { AuditReport } from "../components/AuditReport";
import { useAuth } from "../context/AuthContext";
import { api, handleErr } from "../lib/api";

export default function Onboarding() {
  const { refresh } = useAuth();
  const nav = useNavigate();
  const [stage, setStage] = useState("form");
  const [report, setReport] = useState(null);

  const submit = async (f) => {
    setStage("auditing");
    try {
      const { data: brand } = await api.post("/brands", f);
      const { data } = await api.post(`/brands/${brand.brandId}/audit`, {});
      setReport(data);
      setStage("done");
    } catch (e2) {
      handleErr(e2);
      setStage("failed");
    } finally {
      refresh();
    }
  };

  return (
    <div className="min-h-screen grain p-4 sm:p-10">
      <div className="max-w-5xl mx-auto relative z-10">
        <img src="/logo-mark.png" alt="NamoAI Digital" className="h-12 mb-6" />
        <p className="label-mono mb-2">Onboarding</p>
        <h1 className="text-4xl sm:text-5xl font-bold tracking-tight">Tell us about your brand</h1>
        <p className="text-slate-400 mt-3 mb-10">We will create your brand profile and run a full SEO, AEO and GEO audit (10 credits, available on any paid plan).</p>
        {stage === "form" && (
          <div className="card-n p-6 sm:p-8 fade-up">
            <BrandForm onSubmit={submit}>
              <Button data-testid="onboarding-submit-btn" className="rounded-full px-6">Create brand & run audit <ArrowRight size={16} className="ml-1" /></Button>
            </BrandForm>
          </div>
        )}
        {stage === "auditing" && <div className="card-n"><Spinner label="Crawling your website and running the AI audit... (20-40s)" /></div>}
        {(stage === "done" || stage === "failed") && (
          <div className="space-y-6">
            {report ? <AuditReport r={report} /> : <p className="text-slate-400" data-testid="onboarding-audit-failed">Your brand is saved. Choose a plan to run your full website audit — you can start it anytime from the SEO Auditor.</p>}
            <Button data-testid="onboarding-continue-btn" onClick={() => nav("/")} className="rounded-full">Go to dashboard <ArrowRight size={16} className="ml-1" /></Button>
          </div>
        )}
      </div>
    </div>
  );
}
